import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../Styles/PrivacyPolicy.css";

function PrivacyPolicy() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <main className="privacy_policy_page">
      <div className="privacy_policy_inner">
        <p className="privacy_policy_kicker">PyLoan</p>
        <h1>Privacy Policy</h1>
        <p className="privacy_policy_updated">Last updated: 22 October 2026</p>

        <section>
          <h2>1. About this website</h2>
          <p>
            PyLoan is an independent informational website at pyloan.in. We
            publish educational articles about loans, government-supported
            schemes, eligibility, documents and application questions. We are
            not a bank, NBFC, lender or government authority. We do not accept,
            process, arrange, broker or guarantee loan applications, connect
            applicants with lenders, forward loan leads or receive lender
            referral commissions.
          </p>
        </section>

        <section>
          <h2>2. Information you choose to provide</h2>
          <p>
            If you use the contact form, we may receive your name, email
            address, optional phone number, selected topic and message. Please
            do not send passwords, OTPs, bank login credentials, full card
            numbers or other sensitive financial credentials. We do not ask for
            those details.
          </p>
        </section>

        <section>
          <h2>3. How we use contact information</h2>
          <p>
            We use contact details to read and respond to general questions,
            maintain the website and address privacy or support requests. We do
            not use contact submissions to arrange loans or create lender
            leads. We do not currently run a newsletter or promotional email
            list.
          </p>
        </section>

        <section>
          <h2>4. Form delivery provider</h2>
          <p>
            Contact form submissions are sent through Web3Forms so that the
            message can be delivered to our email inbox. Web3Forms may process
            the submitted data as part of that delivery. Review the provider’s
            current privacy terms before submitting a message. We do not add
            form data to a lender or affiliate database.
          </p>
        </section>

        <section>
          <h2>5. Cookies, analytics and external links</h2>
          <p>
            The current site does not intentionally set advertising cookies or
            run analytics or tracking pixels. This may change if a technical
            service is added; this policy will be updated when that happens.
            Links to official government portals, banks and other websites are
            provided for reference. Those sites have their own privacy terms.
          </p>
        </section>

        <section>
          <h2>6. Retention and security</h2>
          <p>
            We keep a contact message only for as long as needed to respond,
            maintain records or comply with law. We use reasonable safeguards,
            but no internet transmission or storage system can be guaranteed to
            be completely secure.
          </p>
        </section>

        <section>
          <h2>7. Your choices</h2>
          <p>
            You can ask us to access, correct or delete a contact message by
            writing to the email below. We may need to verify the request before
            acting on it.
          </p>
        </section>

        <section>
          <h2>8. Contact</h2>
          <p>
            PyLoan<br />
            B12, Mahipalpur Bypass Road, Mahipalpur, New Delhi - 110037<br />
            <a href="mailto:Mudraloanhelp0@gmail.com">Mudraloanhelp0@gmail.com</a><br />
            <a href="tel:9873691307">+91 9873691307</a>
          </p>
        </section>

        <p className="privacy_policy_footer">
          <Link to="/terms_of_use">Read the Terms of Use</Link>
        </p>
      </div>
    </main>
  );
}

export { PrivacyPolicy };
